<template>
  <page>
    <div class="specialProductList" v-if="isFormalEmp">
      <div :class="'getcardBox ' + productType">
      <van-tabs
        sticky
        swipeable
        @change="switchTab"
        v-model="activeIndex"
        class="member-code-tabs"
      >
        <van-tab
          v-for="(item, index) in productList"
          :key="index"
          :title="item.productName"
        >
          <div class="getcardUrl">
            <!-- <div class="getcardBtn" @click="switchPic('long')">查看宣传海报</div> -->
            <div class="tencentqrcode">
              <img
                :src="item.img"
              />
            </div>
          </div>
        </van-tab>
      </van-tabs>
      </div>
    </div>
  </page>
</template>
<script>
import { Dialog } from 'vant'
import { mapGetters, mapMutations } from 'vuex'
export default {
  data () {
    return {
      box: 'code',
      activeIndex: 0,
      productList: [],
      qrcodeUrl: [],
      productType: 'yes-taba__nav',
      longPicUrl: 'http://img.coocaa.com/java-manage/images/20191216/ebe343f0-aab8-4a26-be03-ecf9197816da.jpg',
      empNo: null
    }
  },
  computed: {
      ...mapGetters(['isFormalEmp']),
  },
  methods: {
    ...mapMutations(['setEmpInfo']),
    switchTab (e) {
      const productList = this.productList[e].img
      if (!productList) {
        this.imgSynthesis(this.productList[e])
      }
    },
    switchPic (type) {
      this.box = type
    },
    imgSynthesis (data) {
      const target = encodeURIComponent(window.location.origin + '/goodsDetail?goodsId=' + data.productId)
      let link = `${window.location.origin}/ad-link/ccfx?pageType=employee&target=${target}&fromCode=${this.empNo}`
      this.$service.imgSynthesis(
        {
          'action': 'combie',
          'background': data.productBackground,
          'backgroundHeight': 1498,
          'backgroundWidth': 750,
          'items': [
            {
              'context': link,
              'coordinateX': 186,
              'coordinateY': 444,
              'shapeHeight': 378,
              'shapeWidth': 378,
              'type': 'qrcode'
            }
          ]
        }
      ).then((res) => {
        const curIndex = this.activeIndex
        this.productList[curIndex].productName = this.productList[curIndex].productName + ' '
        this.productList[curIndex].img = 'data:image/jpg;base64,' + res.data.base64Value
      })
    },
    getProductList () {
      const codeType = this.$route.query.type
      this.$service.getProductList({
        type: codeType
      }).then((res) => {
        const data = res.data
        if (data.length === 1) {
          this.productType = 'no-taba__nav'
        }
        this.productList = data
        this.imgSynthesis(data[0])
      })
    }
  },
  created () {
    this.$service.getCurrentEmpInfo().then((res) => {
      const data = res.data
      if (res.code === 200 && data) {
        this.getProductList()
        this.empNo = data.empNo
        this.setEmpInfo(data);
      } else {
        Dialog.alert({
          title: '提示',
          message: '非合伙人，不能销售会员卡！',
          confirmButtonText: '好的'
        }).then(() => {
          this.$wx.closeWindow()
        })
      }
    })
  }
}
</script>
<style lang="stylus" scoped>
>>> .member-code-tabs .van-tabs__nav
  background rgba(0,0,0,0.5)
>>> .member-code-tabs .van-hairline--top-bottom::after,
>>> .member-code-tabs .van-hairline-unset--top-bottom::after
  display none
>>> .member-code-tabs.van-tabs--line .van-tabs__wrap
  height 40px
>>> .member-code-tabs .van-ellipsis
  color #ffffff
>>> .member-code-tabs .van-tab--active .van-ellipsis
  color #E8D288
>>> .no-taba__nav .member-code-tabs .van-tabs__nav
  display none
>>> .member-code-tabs .van-tabs__line
  background #E8D288
.getcardBox
  height 100vh
  overflow hidden
.member-code-list
  width 100%
  height 50px
  position fixed
  left 0
  top 0
  background rgba(0,0,0,0.5)
  z-index 1000
  color #ffffff
.member-code-list span
  padding 0 20px
  font-size 16px
.main,
.specialProductList
  height 100%
.getcardUrl
  height 100vh
  overflow hidden
  margin-top -40px
.tencentqrcode
  height 100vh
.tencentqrcode img
  margin-top ceil(-( 1498px * (100vw / 750) - 100vh) / 2)
.tencentqrcode img,
.propagandaImage img
  width 100%
  vertical-align top
.getcardBtn
    width 130px
    height 35px
    line-height 35px
    font-size 12px
    position fixed
    left 50%
    bottom 20px
    background #ffffff
    z-index 99
    color #000000
    text-align center
    border-radius 2rem
    margin-left -60px
.toastBtn
  position fixed
  left 0
  top 40%
  text-align center
  color #ffffff
  border-radius 0 5px 5px 0
  background rgba(0,0,0,0.5)
  font-size 12px
  line-height 20px
  width 16px
  padding 5px 2px
.share_erweima
  width 40px
  height 40px
  position fixed
  right 20px
  top 20px
  background #ffffff
</style>
